import { ApiClient } from '../client/ApiClient';
import { ApiResponse } from '../types';
import { KlaviyoResponse } from './types';

export class KlaviyoBackInStoreClient extends ApiClient {
  private readonly _klaviyoBackInStoreUrl: string;
  private readonly _klaviyoEnvironment: string;

  constructor({
    klaviyoEnvironment,
    klaviyoBackInStoreUrl,
  }: {
    klaviyoBackInStoreUrl: string;
    klaviyoEnvironment: string;
  }) {
    super();
    this._klaviyoEnvironment = klaviyoEnvironment;
    this._klaviyoBackInStoreUrl = klaviyoBackInStoreUrl;
  }

  protected get requestHeaders(): Record<string, string> {
    return {
      'Content-Type': 'application/json',
      revision: '2024-10-15',
    };
  }

  backInStoreSubscribe = async ({
    email,
    listId,
  }: {
    email: string;
    listId: string;
  }): Promise<ApiResponse<KlaviyoResponse>> => {
    const { data, statusCode, error } = await this._fetch<KlaviyoResponse>({
      path: `${this._klaviyoBackInStoreUrl}?company_id=${this._klaviyoEnvironment}`,
      method: 'POST',
      body: {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${listId}`,
              },
            },
          },
        },
      },
    });

    if (error) {
      console.log('error from KlaviyoBackInStoreClient', { error, statusCode });
      return { error, statusCode };
    }

    return { data, statusCode };
  };
}
